import * as STRINGS from '../strings'

export default {
  [STRINGS.SAFEWALK_ACTIVATED_TEXT]: 'Recibirás notificaciones cuando su temporizador esté a punto de expirar. Se enviarán alertas si caduca.',
  [STRINGS.SAFEWALK_ALARM_ACTIVE_BODY_TEXT]: 'Su temporizador de registro de Camino Seguro ha expirado. Su organización y/o contactos elegidos han sido alertados. \nSi está seguro/a, cancele la alarma activa a continuación.',
  [STRINGS.SAFEWALK_ALARM_CANCELLED_BODY_TEXT]: 'Su organización y/o contactos elegidos notificaran que su alarma de Camino Seguro han sido cancelada.  Porque es posible que ya hayan sido alertados, puede recibir llamadas o mensajes de texto para confirmar su seguridad.',
  [STRINGS.SAFEWALK_ALARM_ENDED_BODY_TEXT]: 'Su organización y/o contactos elegidos notificaran que su Camino Seguro ha finalizado de manera segura.',
  [STRINGS.SAFEWALK_ALARM_WARNING_BODY_TEXT]: 'Se enviarán alertas con su ubicación y detalles de contacto disponibles si su temporizador expira.',
  [STRINGS.SAFEWALK_BUTTON_ALARM_ACTIVE_TEXT]: 'Alarma de Camino Seguro activada',
  [STRINGS.SAFEWALK_BUTTON_BEGIN_TEXT]: 'Iniciar un Camino Seguro',
  [STRINGS.SAFEWALK_BUTTON_WALK_ACTIVE_TEXT]: 'Camino Seguro activo para',
  [STRINGS.SAFEWALK_BUTTON_WARNING_TEXT]: 'Camino Seguro activo para',
  [STRINGS.SAFEWALK_CONTACTS_DESCRIPTION]: 'Se enviarán alertas con su ubicación y detalles de contacto disponibles si su temporizador expira.',
  [STRINGS.SAFEWALK_CONTACTS_DISCLAIMER]: 'Omnilert solo usará el número de SMS de sus contactos para alertarlos durante su Camino Seguro.',
  [STRINGS.SAFEWALK_CONTACTS_FORM_DESCRIPTION]: 'Opcional: Ingrese los números de SMS de los contactos a continuación para agregarlos a sus notificaciones de Camino Seguro.',
  [STRINGS.SAFEWALK_CUSTOM_DURATION_TEXT]: 'Establezca su propia duración del temporizador.',
  [STRINGS.SAFEWALK_INSTALL_BANNER_BODY]: 'Para una mejor precisión de ubicación, descargue la aplicación. Si continúa, mantenga el navegador abierto y su teléfono desbloqueado para compartir su ubicación si su temporizador expira.',
  [STRINGS.SAFEWALK_INSTALL_BANNER_HEADER]: 'Mejore la precisión de la ubicación de emergencia',
  [STRINGS.SAFEWALK_OFF_CAMPUS_CONTACTS_FORM_DESCRIPTION]: 'Para continuar, ingrese los números de SMS para notificar su Camino Seguro. Si activa una alarma, su ubicación también se compartirá.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_INFO_ONE_TEXT]: 'Su organización le ha permitido usar Camino Seguro fuera del campus o después de las horas de funcionamiento. Para inciar un camino debes agregar contactos para notificar.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_INFO_TWO_TEXT]: 'Para contiuar, selecione hasta (3) contactos para notificar su Camino Seguro y su ubicación en caso de que active una alarma.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_TEXT]: 'Su organización le ha permitido usar Camino Seguro fuera del campus agregando hasta (3) contactos para notificar.',
  [STRINGS.SAFEWALK_ON_CAMPUS_QUESTION_TEXT]: 'Estás en el campus?',
  [STRINGS.SAFEWALK_ON_CAMPUS_TEXT]: 'Su organización puede recibir una notificación cuando comience su camino y si activa una alarma.',
  [STRINGS.SAFEWALK_SMS_DESCRIPTION]: 'Recibirá un SMS y/o notificación automática cuando su temporizador esté a punto de caducar.',
  [STRINGS.SAFEWALK_TIMER_EXPIRY_INFO]: 'Se enviarán alertas con su ubicación y detalles de contacto disponibles si su temporizador expira.',
  
  [STRINGS.BUTTON_DOWNLOAD]: 'Descargar',
  [STRINGS.BUTTON_OPEN_APP]: 'Abierto app',
  [STRINGS.BUTTON_SAFEWALK_ACTIVATE]: 'Comenzar Camino Seguro',
  [STRINGS.BUTTON_SAFEWALK_ADD_CONTACTS]: 'Agregar contactos para notificar',
  [STRINGS.BUTTON_SAFEWALK_CANCEL_ALARM]: 'Cancelar alarma',
  [STRINGS.BUTTON_SAFEWALK_CHECK_IN_TIMER_SET]: 'Registro establecido para {{duration}} minutos',
  [STRINGS.BUTTON_SAFEWALK_CHECKIN_TIMER]: 'Configurar el temporizador de registro de Camino Seguro',
  [STRINGS.BUTTON_SAFEWALK_END_WALK]: 'Final',
  [STRINGS.BUTTON_SAFEWALK_NEW_WALK]: 'Comenzar un nueva Camino Seguro',
  [STRINGS.BUTTON_SAFEWALK_TRIGGER_ALARM]: 'Alarma',
  [STRINGS.BUTTON_CANCEL]: 'Cancelar',
  [STRINGS.BUTTON_CLOSE]: 'Cerrar',
  [STRINGS.BUTTON_CONTINUE]: 'Continuar',
  [STRINGS.BUTTON_DIAL_911_SHORT]: 'Marque 911',
  [STRINGS.BUTTON_DIAL_911]: 'Marque 911 si es una emergencia',
  [STRINGS.BUTTON_EMERGENCY]: 'Mantenga presionado para obtener ayuda',
  [STRINGS.BUTTON_OK]: 'OK',
  [STRINGS.BUTTON_SEND]: 'Enviar',
  [STRINGS.BUTTON_SUBMIT_SILENT_ALERT]: 'Enviar alerta silenciosa',
  [STRINGS.BUTTON_SUBMIT]: 'Enviar',
  [STRINGS.BUTTON_TIP_CATEGORY]: 'Seleccione una categoría de Sugerencia',
  [STRINGS.BUTTON_TIP_LOCATION]: 'Ubicación de su Sugerencia',

  [STRINGS.COMMON_CONFIRM]: 'Yes',
  [STRINGS.COMMON_DENY]: 'No',

  [STRINGS.EMPTY_STATE_RESOURCES]: 'No se encontraron recursos.',

  [STRINGS.ERROR_ACCOUNT_SETUP]:
    'Hay un problema con la configuración de su cuenta. Por favor, póngase en contacto con un administrador.',
  [STRINGS.ERROR_CONFIG_UNDEFINED]:
    'Hay un problema con su configuración. Por favor, póngase en contacto con un administrador para configurar notificación push.',
  [STRINGS.ERROR_FIREBASE]:
    'Hay un problema de la comunicación con nuestro sistema.  Por favor inténtelo otra vez.',
  [STRINGS.ERROR_TITLE]: 'Se ha producido un error',
  [STRINGS.ERROR_VALIDATION_401]:
    'El código de validación que ingresó no es válido..  Por favor asegúrese que ha ingresado su código correctamente.',

  [STRINGS.INDICATOR_NEW_MESSAGES]: 'Mensajes nuevos',
  [STRINGS.INDICATOR_SCROLL]: 'Mensajes no leídos',

  [STRINGS.LABEL_ACCOUNT]: 'Cuenta',
  [STRINGS.LABEL_TIP_CATEGORY]: 'Seleccione una categoría de Sugerencia',
  [STRINGS.LABEL_TIP_LOCATION]: 'Enviar ubicación actual',
  [STRINGS.LABEL_TIP_PRIVATE]: 'Hacer privado',

  [STRINGS.LAUNCH]: 'Lanzamiento',
  [STRINGS.LAUNCH_SCENARIO]: 'Escenario de lanzamiento',
  
  [STRINGS.MESSAGE_LOCATION]: 'Ubicación del mensaje',
  [STRINGS.MESSAGE_LOCATION_ERROR_TOAST]:
    'Your organization has requested your location to assist in the current situation. Your response or status will be sent without location unless you re-enable location access.',
  [STRINGS.MESSAGE_TITLE_TIP]: 'informe de sugerencia',
  [STRINGS.MESSAGE_TITLE_TIP_ANONYMOUS]: 'Informe de sugerencia anónimo {{category}}',
  
  [STRINGS.MODAL_BODY_LOCATION_PERMISSION]:
    'Los permisos de ubicación no están activados. Por favor, activar la ubicación para ayudar a nuestros agentes a ayudarlo mejor.  Las funciones fundamentales no estarán disponibles si rechaza.',
  [STRINGS.MODAL_BODY_LOCATION_PERMISSION_DENIED]:
    'Los permisos de ubicación fueron denegados.  Por favor, active la ubicación yendo a la configuración de su dispositivo.  Después de activar la ubicación, intente nuevamente.',
  [STRINGS.MODAL_BODY_TIP_TITLE]: 'Su sugerencia ha sido enviada. 👍',
  [STRINGS.MODAL_BODY_TIP_TITLE_ANON]: 'Su sugerencia ha sido enviada anónimamente.',
  [STRINGS.MODAL_BODY_TIP_BODY]:
    'Gracias por su informe, no podemos responder directamente a los informes de sugerencias.',
  [STRINGS.MODAL_BODY_TIP_EMERGENCY]:
    'If this is an emergency, please dial local emergency services.',
  [STRINGS.MODAL_TITLE_LOCATION_PERMISSION]: 'Activar servicios de ubicación',
  [STRINGS.MODAL_TITLE_LOCATION_PERMISSION_DENIED]: 'Servicios de ubicación desactivados',
 
  [STRINGS.NO_RESPONSE]: 'Ninguna respuesta',
  [STRINGS.NOT_AUTH_TITLE]: 'Lo sentimos, no tienes permiso para acceder a esta página.',
  [STRINGS.NOT_AUTH_SUBTITLE]: 'Comuníquese con el administrador del sistema si cree que recibió este mensaje por error.',
  [STRINGS.NOT_FOUND_TITLE]: 'Lo sentimos, esta página no está disponible',
  [STRINGS.NOT_FOUND_SUBTITLE]: 'El enlace que tiene puede estar roto, no podemos encontrar el recurso que está buscando.',

  [STRINGS.PRIORITY_HEADER_GUN]: 'Pistola detectada',
  [STRINGS.PRIORITY_HEADER_PANIC]: 'Alerta de botón de pánico',
  [STRINGS.PRIORITY_HEADER_TIP]: 'Alerta de Sugerencia',
  [STRINGS.PRIORITY_FALSE_POSITIVE]: 'Falso positivo',
  [STRINGS.PRIORITY_MENU_RESOLVE]: 'Resolver el problema',
  [STRINGS.PRIORITY_BADGE_RESOLVED]: 'Resuelto',

  [STRINGS.PLACEHOLDER_MESSAGE]: 'Escribe tu mensaje',
  [STRINGS.PLACEHOLDER_RESPONSE]: 'Ingresa la respuesta aquí',
  [STRINGS.PLACEHOLDER_RESOURCES_FILTER]: 'Filtrar recursos',
  [STRINGS.PLACEHOLDER_TIP]: ' Ingrese su Sugerencia aquí ',

  [STRINGS.PUSH_REG_TEXT]: 'La aplicación móvil Omnilert está diseñada para uso móvil. Abra este enlace de registro desde su dispositivo móvil.',

  [STRINGS.SCREEN_TITLE_TIP]: 'Enviar Sugerencia',
  [STRINGS.SCREEN_TITLE_TIP_LOCATION]: 'Ubicación de su Sugerencia',
  [STRINGS.SCREEN_TITLE_TIP_ATTACHMENT]: 'Attachment',
  [STRINGS.SCREEN_TITLE_TIP_CATEGORY]: 'Seleccione una categoría de Sugerencia',
 
  [STRINGS.SECTION_TITLE_ACCOUNT]: 'Cuenta',
  [STRINGS.SECTION_TITLE_DISPLAY]: 'Pantalla',
 
  [STRINGS.TAB_TITLE_MESSAGES]: 'Mensajes',
  [STRINGS.TAB_TITLE_RESOURCES]: 'Recursos',
  [STRINGS.TAB_TITLE_SAFEWALK]: 'Caminata Consciente',
  [STRINGS.TAB_TITLE_TIPS]: 'Sugerencias',
  
  [STRINGS.TIP_CATEGORY_DEFAULT]: 'Ninguna categoría seleccionada',
  [STRINGS.TIP_LOCATION_ERROR_TOAST]:
    'To share the location of your tip with Your organization, please re-enable location access.',
  [STRINGS.TIP_SCREEN_EMERGENCY_LINE_ONE]: 'If this is a safety emergency',
  [STRINGS.TIP_SCREEN_EMERGENCY_LINE_TWO]: 'Dial local emergency services',
 
  [STRINGS.USER]: 'Usuario',
  [STRINGS.USERS]: 'Usuarios',

  [STRINGS.USER_ERROR_DEFAULT]: 'Se ha producido un error desconocido.',
  [STRINGS.USER_ERROR_MAX_UPLOADS]: 'Seleccione un máximo de tres (3) archivos para cargar.',
  [STRINGS.USER_ERROR_1001]:
    'Su dispositivo no se ha eliminado del sistema.  Por favor, póngase en contacto con un administrador.',
  [STRINGS.USER_ERROR_1002]:
    'Su dispositivo no se ha eliminado del sistema.  Por favor, póngase en contacto con un administrador.',
  [STRINGS.USER_ERROR_2001]:
    'Hubo un problema al enviar su mensaje a nuestro servidor.  Por favor, inténtelo de nuevo más tarde.',
  [STRINGS.USER_ERROR_3001]:
    'Hubo un problema al registrar su dispositivo para recibir notificaciones push. Por favor, póngase en contacto con un administrador.',
  [STRINGS.USER_ERROR_3002]:
    'Hubo un problema al registrar su dispositivo para recibir notificaciones push. Por favor, póngase en contacto con un administrador.',
  [STRINGS.USER_ERROR_4001]:
    'Hubo un problema al registrar su dispositivo con el sistema. Por favor, póngase en contacto con un administrador.',
  [STRINGS.USER_ERROR_4002]:
    'Se requiere un código de validación.  Por favor, ingrese un código de validación e intente nuevamente.',
  [STRINGS.USER_ERROR_4003]:
    'Su código de validación está asociado con una cuenta no configurada correctamente.  Por favor, póngase en contacto con un administrador.',
  [STRINGS.USER_ERROR_4004]:
    'Su código de validación no está registrado en nuestro sistema.  Asegúrese de que se ingrese correctamente.',
  [STRINGS.USER_ERROR_4005]:
    'Hay un problema con tu código de validación.  Por favor, póngase en contacto con un administrador.',
  [STRINGS.USER_ERROR_4006]:
    'Su código de validación no tiene la longitud correcta.  Asegúrese de que el código tenga 10 caracteres.',
  [STRINGS.USER_ERROR_5001]:
    'Hubo un problema al marcar un mensaje como leído.  Por favor, inténtelo de nuevo más tarde.'
}
